import { Component, Input, OnDestroy, OnInit }                                      from '@angular/core';
import { AuthService }                                                              from "../../../providers/auth.service";
import { Subject }                                                                  from 'rxjs/Subject';
import { User }                                                                     from '../../../users/models/user';
import { Router }                                                                   from '@angular/router';

@Component({
  selector: 'notifications-messages',
  templateUrl: 'notifications.component.html',
  styleUrls: ["notifications.component.scss"]
})
export class NotificationsMessageComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  private user: User;

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.authService.getUser().subscribe(
      user => this.user = user);
  }

  logout() {
    this.authService.logout().then(() => {
        this.user = null;
        this.router.navigate(['login']);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/notifications/notifications.component.ts